module.exports = __webpack_public_path__ + "img/level5.cabcf1fe.svg";